import React, { useContext, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Stats from "../../components/Stats/Stats";
import NavBar from "../../components/NavBar/NavBar";
import BackButton from "../../components/BackButton/BackButton";
import { DeezerDataContext } from "../../context/DeezerDataContext";
import MusicItem from "../../components/MusicItem/MusicItem";
import LoadMoreButton from "../../components/LoadMoreButton/LoadMoreButton";
import Logo from "../../components/Logo/Logo";

const DetailsMusic = () => {
  const { playlistData } = useContext(DeezerDataContext);
  const [tracksData, setTracksData] = useState();
  const [visibleTracks, setVisibleTracks] = useState(20);
  const params = useParams();
  const location = useLocation();

  // Get playlist data from location state (passed from Link) or search in context data
  const passedPlaylistData = location.state?.playlistData;
  
  const chosenPlaylist = passedPlaylistData || playlistData?.data?.playlists?.items.find(
    (playlist) => playlist && playlist.id.toString() === params.id
  );

  //BUG Fix 228
  let shortenedPLaylistName = chosenPlaylist?.title || "Loading...";
  shortenedPLaylistName =
    shortenedPLaylistName.length > 45
      ? shortenedPLaylistName.slice(0, 45) + "..."
      : shortenedPLaylistName;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.post(`/api/deezer/tracks`, params);
        console.log("Deezer tracks:", data);
        setTracksData(data);
      } catch (error) {
        console.error("Error fetching tracks:", error);
      }
    };
    fetchData();
  }, [params]);

  const loadMoreTracks = () => {
    setVisibleTracks((prevVisibleTracks) => prevVisibleTracks + 20);
  };

  return (
    <div className="main-wrapper center">
      <Logo className={"logo-black"} />
      <BackButton relativeClass={"back-btn-filled"} />
      {chosenPlaylist ? (
        <>
          <div className="gap3">
            <h1 className="playlistname-meditation">{shortenedPLaylistName}</h1>
            <p>PLAYLIST</p>
            <p className="subtitle">{chosenPlaylist.description}</p>
            <Stats />
          </div>
          {tracksData?.data?.slice(0, visibleTracks).map((track) => (
            <MusicItem
              key={track.id}
              link={track.id}
              title={track.title}
              duration={track.duration * 1000}
              hasPreview={!!track.preview}
            />
          ))}
          {visibleTracks < tracksData?.data?.length && (
            <LoadMoreButton onClick={loadMoreTracks} />
          )}
          <NavBar />
        </>
      ) : (
        <p>Loading playlist details...</p>
      )}
    </div>
  );
};

export default DetailsMusic;
